import { useSegmentAnalytics } from "./useSegmentAnalytics";

export const useOnboardingWidgetAnalytics = () => {
  const { trackButtonClickEvent } = useSegmentAnalytics();

  const trackVerifyNowClickEvent = () =>
    trackButtonClickEvent({
      label: "Onboarding widget Verify your information - Verify now button",
      location: "Onboarding widget Verify your information - Verify now button",
      extraProperties: {
        event_type: "Click",
        link_text: "Verify now button",
      },
    });

  const trackVerifyInfoContinueClickEvent = () =>
    trackButtonClickEvent({
      label: "Onboarding widget Verify your information - Continue button",
      location: "Onboarding widget Verify your information - Continue button",
      extraProperties: {
        event_type: "Click",
        link_text: "Continue button",
      },
    });

  const trackCompleteNowClickEvent = () =>
    trackButtonClickEvent({
      label:
        "Onboarding widget Submit your business details - Complete now button",
      location:
        "Onboarding widget Submit your business details - Complete now button",
      extraProperties: {
        event_type: "Click",
        link_text: "Complete now button",
      },
    });

  const trackContinueClickEvent = () =>
    trackButtonClickEvent({
      label: "Onboarding widget Submit your business details - Continue button",
      location:
        "Onboarding widget Submit your business details - Continue button",
      extraProperties: {
        event_type: "Click",
        link_text: "Continue button",
      },
    });

  const trackDismissClickEvent = () =>
    trackButtonClickEvent({
      label: "Onboarding widget Success state - Dismiss button",
      location: "Onboarding widget Success state - Dismiss button",
      extraProperties: {
        event_type: "Click",
        link_text: "Dismiss button",
      },
    });

  const trackReapplyClickEvent = () =>
    trackButtonClickEvent({
      label: "Onboarding widget Unsuccessful state - Reapply button",
      location: "Onboarding widget Unsuccessful state - Reapply button",
      extraProperties: {
        event_type: "Click",
        link_text: "Reapply button",
      },
    });

  return {
    trackVerifyNowClickEvent,
    trackVerifyInfoContinueClickEvent,
    trackCompleteNowClickEvent,
    trackContinueClickEvent,
    trackDismissClickEvent,
    trackReapplyClickEvent,
  };
};
